import { Injectable } from "@angular/core";
import { BehaviorSubject, filter, map } from "rxjs";
import { CpbSection, NavbarTypes } from "talos-careers-page-library";
import { Page, PageModel, SiteConfig, SiteConfigState } from "../models/site.config.models";

@Injectable()
export class BrandingService {
  private siteConfig:BehaviorSubject<SiteConfig|null> = new BehaviorSubject<SiteConfig|null>(null);
  private defaultBranding: SiteConfig = {
    domain: '',
    siteType: '',
    pages: [],
    configurationVersion: 0,
    seoPageDetails: [],
    siteSettings: null,
    navigation: {
      navigationType: NavbarTypes.HORIZONTAL,
      siteNavigationItems: []
    },
    globalStyles: {
      headerLogoUrl: '/assets/logo.svg',
      faviconUrl: '/assets/favicon.ico',
      showCookieBanner: false,
      showLogoInFooter: true,
      socialMediaHandles: {
        companyUrl: '',
        twitterUrl: '',
        facebookUrl: '',
        linkedInUrl: '',
        instagramUrl: ''
      },
      companyName: 'Talos360',
      showPoweredByTalos: true,
      masterBackgroundColour: '',
      primaryButtonBackgroundColour: '',
      primaryButtonTextColour: '',
      secondaryButtonTextColour: '',
      secondaryButtonBackgroundColour: '',
      buttonBorderRadius: '',
      headerFont: '',
      bodyFont: '',
      headingTextColour: '',
      descriptiveTextColour: '',
      lightTextColour: '',
      navigationLogoSize: '',
      sectionSpacing: '',
      enableVacancyImages: false,
      vacancyImageSetId: 0
    },
    obfuscatedId: '',
  }

  get branding$(){
    return this.siteConfig
    .asObservable()
    .pipe(
      filter(value => value !== null),
      map(value => this.mapSiteConfigData(value as SiteConfig))
    );
  }

  private mapSiteConfigData(siteConfig: SiteConfig) {
    const mappedConfig = {
      ...siteConfig,
      pageModels: this.pagesAsPageModels(siteConfig.pages),
      siteSettingsModel: siteConfig.siteSettings
      ? siteConfig.siteSettings
      : {
        googleTagManagerId: '',
        googleTrackingId: ''
      }
    };
    return mappedConfig;
  }

  private pagesAsPageModels(pages: Page[]): PageModel[] {
    return pages.map(page => {
      return {
        ...page,
        sections: tryParseSections(page)
      }
    });

    function tryParseSections(page: Page) {
      try {
        return JSON.parse(page.sectionsJson) as CpbSection[]
      } catch {
        return [];
      }
    }
  }

  addBranding(data:SiteConfig) {
    this.siteConfig.next(data);
  }

  useDefaultBranding() {
    this.siteConfig.next(this.defaultBranding);
  }

  public getDefaultSiteConfigState(): SiteConfigState {
    return {
      ...this.defaultBranding,
      pageModels: [],
      siteSettingsModel: {
        googleTagManagerId: '',
        googleTrackingId: '',
      }
    } as SiteConfigState
  }
}
